import axios from '@/libs/api.request'
const dept = {
  // 门店列表
  getDept: (data) => {
    return axios.post({
      url: '/Dept',
      data: data
    })
  },
  // 获取区域列表
  getDeptArea: () => {
    return axios.get({
      url: '/Dept/area'
    })
  },
  // 获取门店概览
  getDeptFact: (id) => {
    return axios.get({
      url: '/Dept/fact?DeptId='+id
    })
  },
  // 编辑门店概览
  setDeptFact: (data) => {
    return axios.put({
      url: '/Dept/fact',
      data:data
    })
  }
}
export default dept



// WEBPACK FOOTER //
// ./src/api/api-dept.js